<template>
  <div>
    <el-button class="button" type="primary" @click="getDefault()"
      >查询</el-button
    >
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <div class="search-left-top">
        <el-form-item label="消息内容：">
          <el-input v-model="formInline.content"></el-input>
        </el-form-item>
        <el-form-item label="状态：">
          <el-select v-model="formInline.is_push">
            <el-option
              v-for="item in status"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="古籍类型：">
          <el-select v-model="formInline.type">
            <el-option
              v-for="item in bookType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发送时间：">
          <el-date-picker
            v-model="formInline.date"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="dateChange()"
          >
          </el-date-picker>
        </el-form-item>
      </div>
    </el-form>
    <!-- 标题 -->
    <div class="title">
      <div>珍言推送列表</div>
      <div style="display: flex;justify-content: center;align-items: center;">
        <el-button type="primary" @click="add">新增</el-button>
        <el-upload
          class="upload"
          action=""
          :http-request="httpRequest"
          :show-file-list="false"
          :before-upload="beforeAvatarUpload"
          :accept="acceptedFileTypes"
        >
          <el-button type="primary">导入</el-button>
          <el-button type="primary" @click="downFile">下载模板文件</el-button>
        </el-upload>
      </div>
    </div>
    <el-table
      :data="zhenyanData"
      border
      style="width: 100%"
      v-loading="loading"
    >
      <el-table-column prop="id" label="ID" align="center" width="150">
      </el-table-column>
      <el-table-column prop="title" label="标题" align="center" width="150">
      </el-table-column>
      <el-table-column prop="content" label="内容" align="center">
      </el-table-column>
      <el-table-column prop="type_id" label="古籍ID" align="center" width="150">
      </el-table-column>
      <el-table-column prop="type" label="类型" align="center" width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.type == 1">域外</span>
          <span v-if="scope.row.type == 2">基础</span>
          <span v-if="scope.row.type == 3">孤本</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="push_time"
        label="推送时间"
        align="center"
        width="150"
      >
      </el-table-column>
      <el-table-column prop="is_push" label="状态" align="center" width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.is_push == 0">待生效</span>
          <span v-if="scope.row.is_push == 1">待推送</span>
          <span v-if="scope.row.is_push == 2">已推送</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="400">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.is_push == 0"
            type="text"
            @click="edit(scope.row)"
            >编辑</el-button
          >
          <el-button
            v-if="scope.row.is_push == 0"
            type="text"
            @click="send(scope.row)"
            >生效</el-button
          >
          <el-button type="text" @click="del(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination" v-if="totalPages > 1">
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="currentPage"
        :page-size="page_size"
        :total="pageTotal"
        @current-change="handlePageChange"
      ></el-pagination>
    </div>

    <!-- 珍言编辑弹出框 -->
    <el-dialog
      :visible.sync="editZhenyanVisible"
      width="50%"
      :close-on-click-modal="false"
      :title="editTitle"
      center
    >
      <el-form ref="ruleForm" :model="zhenyanForm" label-width="180px">
        <el-form-item label="标题：">
          <el-input type="text" v-model="zhenyanForm.title"></el-input>
        </el-form-item>
        <el-form-item label="内容：">
          <el-input type="textarea" v-model="zhenyanForm.content"></el-input>
        </el-form-item>
        <el-form-item label="关联古籍：">
          <el-input
            v-if="zhenyanForm.book_name != ''"
            text="textarea"
            v-model="zhenyanForm.book_name"
          ></el-input>
          <el-button type="primary" @click="addBook">添加</el-button>
        </el-form-item>
        <el-form-item label="推送时间：">
          <el-date-picker
            v-model="zhenyanForm.push_time"
            type="datetime"
            placeholder="选择日期时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerOptions"
            @change="change($event)"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer self-dialog-footer">
        <el-button type="primary" @click="saveEdit('ruleForm')"
          >保 存</el-button
        >
        <el-button type="primary" @click="editZhenyanVisible = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
    <!-- 添加古籍 -->
    <el-dialog title="古籍列表" :visible.sync="bookDialog" width="40%">
      <el-form :inline="true" :model="bookData" class="demo-form-inline">
        <el-form-item label="古籍名称">
          <el-input v-model="bookData.title" placeholder="古籍名称"></el-input>
        </el-form-item>
        <el-form-item label="古籍类型">
          <el-select v-model="bookData.type" placeholder="古籍类型">
            <el-option label="域外" value="1"></el-option>
            <el-option label="基础" value="2"></el-option>
            <el-option label="孤本" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="float: right">
          <el-button type="primary" @click="getBookList">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table
        @current-change="handleSelectionChange"
        tooltip-effect="dark"
        :data="BooktableData"
        style="width: 100%"
        v-loading="loadings"
        ref="usermultipleTable"
        highlight-current-row
      >
        <el-table-column prop="id" label="古籍ID"> </el-table-column>
        <el-table-column label="古籍名称">
          <template slot-scope="scope">{{
            scope.row.title ? scope.row.title : scope.row.name
          }}</template>
        </el-table-column>
      </el-table>
      <div class="pagination" v-if="book_totalPages > 10">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="bookCurrentPage"
          :page-size="book_page_size"
          :total="book_pageTotal"
          @current-change="handleBookPageChange"
        ></el-pagination>
      </div>
      <div style="margin-top: 10px">
        <el-button type="primary" @click="cancelSelectBook"> 取消 </el-button>
        <el-button type="primary" @click="okSelectBook"> 确认 </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import http from "../../../api/zkApiConfig";
export default {
  data() {
    return {
      send_date: "",
      my_file: "",
      acceptedFileTypes: ".xlsx",
      bookData: {
        type: "1",
      },
      bookSelectData: [],
      bookDialog: false,
      loadings: false,
      BooktableData: [],
      bookCurrentPage: 1,
      book_totalPages: 1,
      book_pageTotal: 10,
      book_page_size: 10,
      book_page_index: 1,
      id: "",
      is_edit: false,
      editZhenyanVisible: false,
      editTitle: "珍言详情页",
      loading: false,
      formInline: {
        type: "",
        is_push: 3,
      },
      zhenyanForm: {
        book_id: "",
        book_type: "",
        book_name: "",
      },
      zhenyanData: [],
      //   分页
      currentPage: 1,
      totalPages: 1,
      page_size: 10,
      pageTotal: 10,
      page_index: 10,
      status: [
        {
          value: 0,
          label: "待生效",
        },
        {
          value: 1,
          label: "待推送",
        },
        {
          value: 2,
          label: "已推送",
        },
        {
          value: 3,
          label: "全部",
        },
      ],
      bookType: [
        {
          value: 1,
          label: "域外",
        },
        {
          value: 2,
          label: "基础",
        },
        {
          value: 3,
          label: "孤本",
        },
        {
          value: "",
          label: "全部",
        },
      ],
      pickerOptions: {
        disabledDate(time) {
          const currentDate = new Date();
          const thirtyDaysLater = new Date();
          thirtyDaysLater.setDate(currentDate.getDate() + 30);
          return (
            time.getTime() < currentDate.getTime() - 8.64e7 ||
            time.getTime() > thirtyDaysLater.getTime()
          );
        },
      },
    };
  },
  mounted() {
    this.getDefault();
  },
  methods: {
    // 发送时间
    dateChange() {
      this.formInline.start_time = this.formInline.date[0];
      this.formInline.end_time = this.formInline.date[1];
    },
    // 推送时间
    change(e) {
      const date = new Date(e);
      date.setSeconds(0); // 将秒数设置为 0，舍弃秒的部分
      date.setMilliseconds(0); // 将毫秒数设置为 0，舍弃毫秒的部分
      this.send_date = date.getTime(); // 获取精确到分钟的时间戳
    },
    // 添加古籍
    addBook() {
      this.bookDialog = true;
      this.getBookList();
    },
    // 古籍列表
    getBookList() {
      let params = {
        page_size: this.book_page_size,
        page: this.bookCurrentPage,
        title: this.bookData.title,
      };
      this.loadings = true;
      if (this.bookData.type == 3) {
        http
          .get("admin/admin_books/wq_list", { params: params })
          .then((res) => {
            if (res.data.status_code == 200) {
              let data = res.data.data.data;
              this.BooktableData = data;
              this.bookCurrentPage = Number(res.data.data.current_page);
              this.book_totalPages = res.data.data.total;
              this.book_pageTotal = this.book_totalPages * this.book_page_size;
              this.loadings = false;
            }
          });
      } else if (this.bookData.type == 2) {
        http
          .get("admin/admin_books/zk_list", { params: params })
          .then((res) => {
            if (res.data.status_code == 200) {
              let data = res.data.data.data;
              this.BooktableData = data;
              this.bookCurrentPage = Number(res.data.data.current_page);
              this.book_totalPages = res.data.data.total;
              this.book_pageTotal = this.book_totalPages * this.book_page_size;
              this.loadings = false;
            }
          });
      } else if (this.bookData.type == 1) {
        http
          .get("admin/admin_books/yw_list", { params: params })
          .then((res) => {
            if (res.data.status_code == 200) {
              let data = res.data.data.data;
              this.BooktableData = data;
              this.bookCurrentPage = Number(res.data.data.current_page);
              this.book_totalPages = res.data.data.total;
              this.book_pageTotal = this.book_totalPages * this.book_page_size;
              this.loadings = false;
            }
          });
      } else {
        return false;
      }
    },
    // 选择古籍类型 域外 基础 孤本
    handleSelectionChange(val) {
      console.log(val);
      this.bookSelectData = val;
    },
    // 取消选择书籍
    cancelSelectBook() {
      this.bookDialog = false;
    },
    // 选择书籍
    okSelectBook() {
      this.zhenyanForm.type_id = this.bookSelectData.id;
      this.zhenyanForm.type = this.bookData.type;
      this.zhenyanForm.book_name = this.bookSelectData.name
        ? this.bookSelectData.name
        : this.bookSelectData.title;
      this.bookDialog = false;
    },
    // 关联古籍分页导航
    handleBookPageChange(val) {
      console.log(val);
      this.bookSelectData = val;
      this.bookCurrentPage = val;
      this.getBookList();
    },
    // 下载模版文件
    downFile() {
      window.location.href =
        "https://haiwei-public.oss-cn-shanghai.aliyuncs.com/template/%E6%AF%8F%E6%97%A5%E7%8F%8D%E8%A8%80%E6%8E%A8%E9%80%81%E6%A8%A1%E6%9D%BF.xlsx";
    },
    //验证文件类型
    beforeAvatarUpload(file) {
      const isXls =
        file.type === "application/vnd.ms-excel"
          ? true
          : file.type ===
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          ? true
          : false;
      if (!isXls) {
        this.$message.error("上传的文件只能是xlsx格式!");
      }
      return isXls;
    },
    // ---------------导入
    httpRequest(param) {
      let formData = new FormData();
      formData.append("my_file", param.file);
      http.post("/admin/zsk/push/zy_import", formData).then((res) => {
        if (res.data.status_code == 200) {
          this.$message.success("已导入");
          this.getDefault();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 查询列表
    getDefault() {
      this.loading = true;
      let params = {
        page: this.currentPage,
        page_size: this.page_size,
        is_push: this.formInline.is_push,
        start_time: this.formInline.start_time,
        end_time: this.formInline.end_time,
        content: this.formInline.content,
      };
      http.get("/admin/zsk/push/zy_list", { params: params }).then((res) => {
        if (res.data.status_code == 200) {
          this.zhenyanData = res.data.data.data;
          this.currentPage = Number(res.data.data.current_page);
          this.totalPages = res.data.data.last_page;
          this.pageTotal = this.totalPages * this.page_size;
          this.loading = false;
        }
      });
    },
    // 新增
    add() {
      this.is_edit = false;
      this.zhenyanForm = {};
      this.editZhenyanVisible = true;
    },
    // 编辑
    edit(row) {
      this.id = row.id;
      this.zhenyanForm = row;
      this.is_edit = true;
      this.editZhenyanVisible = true;
      // this.getInfo();
    },
    // 删除
    del(row) {
      let that = this;
      that
        .$confirm("确定要删除吗？", "提示", {
          type: "warning",
        })
        .then(() => {
          http.delete("/admin/zsk/push/zy/" + row.id).then((res) => {
            if (res.data.status_code == 200) {
              that.getDefault();
              that.$message.success("已删除");
            } else {
              that.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {});
    },
    // 立即发送
    send(row) {
      let that = this;
      that
        .$confirm("确定要发送吗？", "提示", {
          type: "warning",
        })
        .then(() => {
          http.post("/admin/zsk/push_zy/" + row.id).then((res) => {
            if (res.data.status_code == 200) {
              that.getDefault();
              that.$message.success("已发送");
            } else {
              that.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {});
    },
    // 提交
    saveEdit() {
      if (this.is_edit == true) {
        if (this.send_date < new Date().getTime()) {
          this.$message.error("推送时间不能小于当前时间");
        } else {
          let params = {
            title: this.zhenyanForm.title,
            content: this.zhenyanForm.content,
            type_id: this.zhenyanForm.type_id,
            type: this.zhenyanForm.type,
            push_time: this.zhenyanForm.push_time,
          };
          http.put("/admin/zsk/push/zy/" + this.id, params).then((res) => {
            if (res.data.status_code == 200) {
              this.$message.success("修改成功");
              this.getDefault();
              this.editZhenyanVisible = false;
            } else {
              this.$message.error(res.data.msg);
            }
          });
        }
      } else {
        if (this.send_date < new Date().getTime()) {
          this.$message.error("推送时间不能小于当前时间");
        } else {
          let params = {
            title: this.zhenyanForm.title,
            content: this.zhenyanForm.content,
            type_id: this.zhenyanForm.type_id,
            type: this.zhenyanForm.type,
            push_time: this.zhenyanForm.push_time,
          };
          http.post("/admin/zsk/push/zy/add", params).then((res) => {
            if (res.data.status_code == 200) {
              this.$message.success("新增成功");
              this.getDefault();
              this.editZhenyanVisible = false;
            } else {
              this.$message.error(res.data.msg);
            }
          });
        }
      }
    },
    // 分页导航
    handlePageChange(val) {
      this.currentPage = val;
      this.getDefault();
    },
  },
};
</script>

<style scoped>
.header-tab {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.button {
  height: 40px;
  position: absolute;
  right: 28px;
  z-index: 999;
}
.title {
  width: 100%;
  padding: 10px 0;
  font-size: 22px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.upload {
  height: 32px;
  margin-left: 10px;
}
/deep/.el-upload {
  height: 32px;
  border: none;
}
/deep/#tab-1-1 {
  width: 200px !important;
}
/deep/#tab-1-2 {
  width: 200px !important;
}
/deep/.el-tabs__item {
  width: 300px !important;
  text-align: center;
}
/deep/.is-active {
  border-bottom-color: #409eff !important;
}
/deep/.el-table__header {
  width: 100% !important;
}
/deep/.el-table__empty-block {
  width: 100% !important;
}
/deep/.el-table__body {
  width: 100% !important;
}
</style>
